import React, { useEffect, useState } from "react";
import { Stack, Box, Typography, Button } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useResponsive from "../../hooks/useResponsive";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../layout/dashboard/header";
import { InputCustom } from "../../components/UIElements/input-ui";
import HospitalDetailsContent from "../../components/hospital/HospitalDetailsContent";
import { useNotificationService } from "../../components/notification";
import { useAuth } from "../../hooks/useAuth";
import { useMutation } from "@tanstack/react-query";
import { apiGetFacilityById } from "../../api/facility";
import { getUrlPathId } from "../../utils/url-id";
import {
  FacilityListProps,
  FacilityListPropsDummy,
} from "../../interface/facility";
import BackButton from "../../components/UIElements/BackButton";

const HospitalDetails = () => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const isSmall = useResponsive("down", "sm", "xl");
  const navigate = useNavigate();
  const { showNotification } = useNotificationService();
  const { token } = useAuth();
  const location = useLocation();

  const [facility_info, setFacility_info] = useState<FacilityListProps>(
    FacilityListPropsDummy
  );

  
  useEffect(() => {
    const jobId = getUrlPathId(location?.pathname);
    const fields = { facilityId: jobId, token: token };
    mutation.mutate(fields);
  }, []);
  
  const mutation = useMutation({
    mutationFn: (fields: { facilityId: string; token: string }) =>
      apiGetFacilityById(fields),
    onSuccess: (data) => {
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
        return;
      }
      if ("data" in data) {
        setFacility_info(data.data?.data);
        
      }
    },
    onError: (error) => {
      showNotification("Fetch process failed", "error");
    },
  });
  
  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
          <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: theme.palette.secondary.dark,
              }}
            >
              Hospital Management
            </Typography>
           
          </Stack>
        </Box>
      </Header>
      <HospitalDetailsContent facilityInfo={facility_info} loading={mutation.isPending} />
    </>
  );
};

export default HospitalDetails;
